(function () {
  'use strict';

  document.documentElement.style.setProperty(
    '--scrollbar-width',
    (window.innerWidth - document.documentElement.clientWidth) + 'px'
  );

  function init() {
    const overlay = document.getElementById('burger-overlay');
    if (!overlay) return;

    const closeBtn = overlay.querySelector('.burger-close');

    // ── Ouvrir ──
    function openBurger() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('burger-open');
    }

    // ── Fermer ──
    function closeBurger() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('burger-open');
      // Réinitialiser les panneaux après la transition
      setTimeout(function () {
        overlay.querySelectorAll('.burger-nav__panel').forEach(function (p) {
          p.classList.remove('is-active', 'is-exiting');
        });
        const l1 = document.getElementById('burger-panel-l1');
        if (l1) l1.classList.add('is-active');
      }, 350);
    }

    // ── Trigger ──
    const burgerTrigger = document.getElementById('burger-trigger');
    if (burgerTrigger) {
      burgerTrigger.addEventListener('click', openBurger);
    }

    // ── Fermer via bouton ──
    if (closeBtn) {
      closeBtn.addEventListener('click', closeBurger);
    }

    // ── Fermer via backdrop ──
    overlay.addEventListener('click', function (e) {
      if (!e.target.closest('.burger-panel')) {
        closeBurger();
      }
    });

    // ── Fermer via Escape ──
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeBurger();
      }
    });

    // ── Navigation tiroirs ──
function showPanel(targetId, direction) {
  const target = document.getElementById(targetId);
  if (!target) return;

  const current = overlay.querySelector('.burger-nav__panel.is-active');
  if (!current || current === target) return;

  if (direction === 'back') {
    // Retour : current sort vers la droite, target entre depuis la gauche
    current.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    current.style.transform = 'translateX(100%)';
    target.style.transition = 'none';
    target.style.transform = 'translateX(-100%)';
    target.classList.add('is-active');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        target.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        target.style.transform = 'translateX(0)';
      });
    });
  } else {
    // Avant : current sort vers la gauche, target entre depuis la droite
    current.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    current.style.transform = 'translateX(-30%)';
    target.style.transition = 'none';
    target.style.transform = 'translateX(100%)';
    target.classList.add('is-active');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        target.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        target.style.transform = 'translateX(0)';
      });
    });
  }

  setTimeout(function () {
    current.classList.remove('is-active');
    current.style.transform = '';
    current.style.transition = '';
    target.style.transition = '';
  }, 310);
}

overlay.querySelectorAll('.burger-nav__toggle').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const targetId = btn.dataset.target;
    if (targetId) showPanel(targetId, 'forward');
  });
});

overlay.querySelectorAll('.burger-nav__back').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const targetId = btn.dataset.target;
    if (targetId) showPanel(targetId, 'back');
  });
});


    // ── Modale localisation ──
    const localeTrigger = document.getElementById('burger-locale-trigger');
    const localeModal = document.getElementById('burger-locale-modal');
    const localeClose = document.getElementById('burger-locale-close');
    const localeBackdrop = localeModal ? localeModal.querySelector('.burger-locale-modal__backdrop') : null;

    function openLocaleModal() {
      if (!localeModal) return;
      localeModal.classList.add('is-open');
      localeModal.setAttribute('aria-hidden', 'false');
      if (localeTrigger) localeTrigger.setAttribute('aria-expanded', 'true');
    }

    function closeLocaleModal() {
      if (!localeModal) return;
      localeModal.classList.remove('is-open');
      localeModal.setAttribute('aria-hidden', 'true');
      if (localeTrigger) localeTrigger.setAttribute('aria-expanded', 'false');
    }

    if (localeTrigger) {
      localeTrigger.addEventListener('click', openLocaleModal);
    }

    if (localeClose) {
      localeClose.addEventListener('click', closeLocaleModal);
    }

    if (localeBackdrop) {
      localeBackdrop.addEventListener('click', closeLocaleModal);
    }

    // Mettre à jour locale_code au clic sur un pays avec langue
    const localeForm = document.querySelector('.burger-locale-form');
    if (localeForm) {
      localeForm.querySelectorAll('.burger-locale-option[data-locale]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const localeInput = localeForm.querySelector('input[name="locale_code"]');
          if (localeInput) localeInput.value = btn.dataset.locale;
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();